"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-four/sections/footerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FooterSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "About" | "Contact Us" | "Hospitals" | "Specialities" | "Clinics" */
    link0Text: ReactNode;
    /** Detected variants: "all_routes.aboutUs" | "all_routes.contactUs" | "all_routes.hospitals" | "all_routes.speciality" | "all_routes.clinics" */
    href: string;
};
export type HomeFourFooterSectionGeneratedProps = {
    footerDiv0Div0Div0ClassName?: string;
    /** Default: "all_routes.home4" */
    footerDiv0Div0Div0Div0Div0Div0Link0LinkHref?: string;
    footerDiv0Div0Div0Div0Div0Div0Link0LinkVisible?: boolean;
    footerDiv0Div0Div0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "logo" */
    footerDiv0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-04.svg" */
    footerDiv0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageSrc?: string;
    footerDiv0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageVisible?: boolean;
    footerDiv0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Supporting you to keep your child healthy with easy access to high-quality paediatric care." */
    footerDiv0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "Company" */
    footerDiv0Div0Div0Div1H40H4Text?: ReactNode;
    footerDiv0Div0Div0Div1H40H4Visible?: boolean;
    footerDiv0Div0Div0Div1H40H4Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div1H40H4Props?: Partial<ComponentProps<"h4">>;
    footerDiv0Div0Div0Div2Form0FormVisible?: boolean;
    footerDiv0Div0Div0Div2Form0FormRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div2Form0FormProps?: Partial<ComponentProps<"form">>;
    /** Default: "Subscribe" */
    footerDiv0Div0Div0Div2Form0Button0ButtonText?: ReactNode;
    footerDiv0Div0Div0Div2Form0Button0ButtonVisible?: boolean;
    footerDiv0Div0Div0Div2Form0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div2Form0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "Enter Email Address" */
    footerDiv0Div0Div0Div2Form0Input0InputPlaceholder?: string;
    /** Default: "Subscribe" */
    footerDiv0Div0Div0Div2H40H4Text?: ReactNode;
    footerDiv0Div0Div0Div2H40H4Visible?: boolean;
    footerDiv0Div0Div0Div2H40H4Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div2H40H4Props?: Partial<ComponentProps<"h4">>;
    /** Default: "© 2025 Doccure. All Rights Reserved" */
    footerDiv1P0PText?: ReactNode;
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUls: FooterSectionUlsItem[];
    footerSectionUlsItemWrapper?: (item: FooterSectionUlsItem, content: ReactNode) => ReactNode;
    footerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkVisible?: boolean;
    footerSectionUlsLinkRenderer?: (item: FooterSectionUlsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeFourFooterSectionGenerated: FC<HomeFourFooterSectionGeneratedProps> = ({
    footerDiv0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageAlt = "logo",
    footerDiv0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-04.svg",
    footerDiv0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageVisible,
    footerDiv0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageRenderer,
    footerDiv0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageProps,
    footerDiv0Div0Div0Div0Div0Div0Link0LinkHref = "all_routes.home4",
    footerDiv0Div0Div0Div0Div0Div0Link0LinkVisible,
    footerDiv0Div0Div0Div0Div0Div0Link0LinkRenderer,
    footerDiv0Div0Div0Div0Div0Div0Link0LinkProps,
    footerDiv0Div0Div0Div0Div0P0PText = "Supporting you to keep your child healthy with easy access to high-quality paediatric care.",
    footerDiv0Div0Div0Div1H40H4Text = "Company",
    footerDiv0Div0Div0Div1H40H4Visible,
    footerDiv0Div0Div0Div1H40H4Renderer,
    footerDiv0Div0Div0Div1H40H4Props,
    footerDiv0Div0Div0Div2Form0Button0ButtonText = "Subscribe",
    footerDiv0Div0Div0Div2Form0Button0ButtonVisible,
    footerDiv0Div0Div0Div2Form0Button0ButtonRenderer,
    footerDiv0Div0Div0Div2Form0Button0ButtonProps,
    footerDiv0Div0Div0Div2Form0Input0InputPlaceholder = "Enter Email Address",
    footerDiv0Div0Div0Div2H40H4Text = "Subscribe",
    footerDiv0Div0Div0Div2H40H4Visible,
    footerDiv0Div0Div0Div2H40H4Renderer,
    footerDiv0Div0Div0Div2H40H4Props,
    footerDiv1P0PText = "© 2025 Doccure. All Rights Reserved",
    footerDiv0Div0Div0Div2Form0FormVisible,
    footerDiv0Div0Div0Div2Form0FormRenderer,
    footerDiv0Div0Div0Div2Form0FormProps,
    liLink0LinkProps,
    footerDiv0Div0Div0ClassName,
    footerSectionUls,
    footerSectionUlsItemWrapper,
    footerSectionUlsRenderer,
    footerSectionUlsLinkVisible,
    footerSectionUlsLinkRenderer,
    footerSectionUlsLinkProps,
}) => {
    return (
        <footer className="footer-four">
            <div className="footer-top">
                <div className="container">
                    <div className={footerDiv0Div0Div0ClassName ?? "row g-4"}>
                        <div className="col-xl-4 col-lg-3 col-md-6">
                            <div className="footer-widget footer-about">
                                <div className="footer-logo">
                                    {renderNode(footerDiv0Div0Div0Div0Div0Div0Link0LinkVisible, footerDiv0Div0Div0Div0Div0Div0Link0LinkRenderer, (
                                        <SmartLink href={footerDiv0Div0Div0Div0Div0Div0Link0LinkHref} {...(footerDiv0Div0Div0Div0Div0Div0Link0LinkProps ?? {})}>
                                            {renderNode(footerDiv0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageVisible, footerDiv0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageRenderer, (
                                                <SmartImage src={footerDiv0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageSrc} alt={footerDiv0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageAlt} className="img-fluid" {...(footerDiv0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageProps ?? {})} />
                                            ))}
                                        </SmartLink>
                                    ))}
                                </div>
                                <p>{footerDiv0Div0Div0Div0Div0P0PText}</p>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6">
                            {renderNode(footerDiv0Div0Div0Div1H40H4Visible, footerDiv0Div0Div0Div1H40H4Renderer, (
                                <h4 className="footer-title" {...(footerDiv0Div0Div0Div1H40H4Props ?? {})}>{footerDiv0Div0Div0Div1H40H4Text}</h4>
                            ))}
                            <ul className="footer-menu">
                                {renderCollectionNode(
                                    footerSectionUls,
                                    (item: FooterSectionUlsItem) => (
                                        <li key={item.key}>
                                            {renderItemNode(footerSectionUlsLinkVisible, footerSectionUlsLinkRenderer, item, (
                                                <SmartLink href={item.href} {...(typeof footerSectionUlsLinkProps === "function" ? footerSectionUlsLinkProps(item) : (footerSectionUlsLinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                            ))}
                                        </li>
                                    ),
                                    footerSectionUlsItemWrapper,
                                    footerSectionUlsRenderer
                                )}
                            </ul>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {renderNode(footerDiv0Div0Div0Div2H40H4Visible, footerDiv0Div0Div0Div2H40H4Renderer, (
                                <h4 className="footer-title" {...(footerDiv0Div0Div0Div2H40H4Props ?? {})}>{footerDiv0Div0Div0Div2H40H4Text}</h4>
                            ))}
                            {renderNode(footerDiv0Div0Div0Div2Form0FormVisible, footerDiv0Div0Div0Div2Form0FormRenderer, (
                                <form className="subscribe-input" {...(footerDiv0Div0Div0Div2Form0FormProps ?? {})}>
                                    <input type="email" className="form-control" placeholder={footerDiv0Div0Div0Div2Form0Input0InputPlaceholder} />
                                    {renderNode(footerDiv0Div0Div0Div2Form0Button0ButtonVisible, footerDiv0Div0Div0Div2Form0Button0ButtonRenderer, (
                                        <button className="btn btn-secondary" {...(footerDiv0Div0Div0Div2Form0Button0ButtonProps ?? {})}>{footerDiv0Div0Div0Div2Form0Button0ButtonText}</button>
                                    ))}
                                </form>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <p className="mb-0">{footerDiv1P0PText}</p>
            </div>
            <div className="progress-four" data-template-tag="ScrollProgressCircle" />
        </footer>
    );
};

export default HomeFourFooterSectionGenerated;
